import React, { useMemo } from 'react'
import { CartItem } from 'orders/schema'
import { ReactTable, TableColumn } from 'uiComponents/table/reactTable'
import { useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import Money from 'uiComponents/money'
import { useTranslation } from 'translations'

const emptyData = [] as any[]

interface CartItemTableProps {
    cartItems: CartItem[]
}

const CartItemTable: React.FC<CartItemTableProps> = ({ cartItems }) => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()

    const columns = useMemo(
        (): TableColumn<CartItem>[] => [
            {
                accessor: 'productName.en',
                Header: t('orders.cart.items.product'),
                width: '24rem',
                Cell: ({ value }) => <span title={value}>{value}</span>,
            },
            {
                accessor: 'productNumericId',
                Header: t('orders.cart.items.productId'),
                width: '4rem',
                Cell: ({ value }) => <span title={value}>{value}</span>,
            },
            {
                accessor: 'price',
                Header: t('orders.cart.items.price'),
                width: '3.75rem',
                Cell: ({ value }) => <Money amount={value} accountSlug={accountSlug} />,
            },
            {
                accessor: 'amount',
                width: '2.5rem',
                Header: t('orders.cart.items.qty'),
                align: 'center',
            },
        ],
        [accountSlug],
    )

    return (
        <ReactTable
            size="small"
            elevation={false}
            columns={columns}
            storeStateInQuery={false}
            bordered={false}
            data={cartItems || emptyData}
            tableProps={{
                className: 'cart-item-table',
            }}
        />
    )
}

export default CartItemTable
